<template>
    <!-- <div class="card card-model">
        <a href="javascript:void(0)" @click.prevent="onClick($event)">
            <div class="card-thumbnail" :style="imageStyle"></div>
            <div class="card-caption">
                <h3>{{ model.fullname }}</h3>
            </div>
        </a>
    </div> -->

    <div class="card card-model card-hover">
        <a href="#" @click.prevent="onClick($event)">
            <div class="card-thumbnail" :style="imageStyle"></div>

            <div class="card-body">
                <h4 class="card-title">{{ model.fullname }}</h4>
                <p class="card-text">
                    <currency v-if="price" :value="price"></currency>
                    <currency-range
                        v-if="!price"
                        :min-value="model.min_price"
                        :max-value="model.max_price"
                    ></currency-range>
                </p>
            </div>
        </a>
    </div>
</template>

<style lang="scss" scoped>
.card-model {
    width: 100%;
    margin-bottom: 30px;

    background-color: darken(#ffffff, 2%);

    > a {
        color: inherit;
        text-decoration: none;

        &:hover {
            .card-caption {
                h3 {
                    color: #2ab27b;
                }
            }
        }
    }

    .card-thumbnail {
        height: 160px;
        background-position: 50% 50%;
        background-size: contain;
        background-repeat: no-repeat;
    }

    .card-body {
        .card-title {
            height: 56px;
        }
    }

    .card-caption {
        text-align: center;
        padding-top: 5px;

        h3 {
            font-size: 16px;
            font-weight: bold;
            margin: 0;
        }
    }
}

.card-hover {
    &:hover {
        background-color: darken(#ffffff, 3%);
    }
}
</style>

<script>
import CurrencyRange from "../../components/CurrencyRange";
const defaultImage = require("../../../img/missing-boat-image.png");

export default {
    components: {
        CurrencyRange,
    },

    props: {
        model: {
            type: Object,
            required: true,
        },
        price: {
            type: Number,
            required: false,
        },
    },

    methods: {
        onClick(event) {
            this.$emit("click", this.model);
            return false;
        },
    },

    computed: {
        imageStyle: function () {
            let url = this.model.image ? this.model.image : defaultImage;

            return "background-image: url(" + url + ")";
        },
    },
};
</script>
